'use client';

import { useLocalizationContext } from "../internals/hooks/useUtils.js";
export var usePickersTranslations = function usePickersTranslations() {
  return useLocalizationContext().localeText;
};